import * as React from "react";

import classes from './index.module.scss';
import { Grid } from '@material-ui/core';

const CategoryHeader = (props: any) => {
  return (
    <div className={classes.navbar} >
      <Grid container>
        {props.categories?.map(cat => (<Grid container item lg={1} className="text-center">
          <p className={classes.link} onClick={() => props.changeCategory(cat.id)}>{cat.name}</p>
        </Grid>))}
        <Grid container item lg={1} className="text-center">
          <p className={classes.link} onClick={() => props.changeCategory(" ")}>همه</p>
        </Grid>
      </Grid>
    </div>
  )
}

export default CategoryHeader